module.exports = __webpack_public_path__ + "img/txt_keyvisual.d41de370.svg";